"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _IconClose = _interopRequireDefault(require("../Icons/IconClose"));

var _IconWarning = _interopRequireDefault(require("../Icons/IconWarning"));

var _IconComplete = _interopRequireDefault(require("../Icons/IconComplete"));

var _IconError = _interopRequireDefault(require("../Icons/IconError"));

var _IconInfoOutline = _interopRequireDefault(require("../Icons/IconInfoOutline"));
/** Banners showing status messages */


var Alert = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Alert, _React$Component);

  function Alert() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Alert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Alert)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isOpen: true
    };

    _this.handleCloseClick = function () {
      _this.setState({
        isOpen: false
      });

      if (_this.props.onCloseClick) _this.props.onCloseClick();
    };

    return _this;
  }

  (0, _createClass2["default"])(Alert, [{
    key: "renderIcon",
    value: function renderIcon(type) {
      switch (type) {
        case "success":
          return /*#__PURE__*/_react["default"].createElement(_IconComplete["default"], null);

        case "warning":
          return /*#__PURE__*/_react["default"].createElement(_IconWarning["default"], null);

        case "danger":
          return /*#__PURE__*/_react["default"].createElement(_IconError["default"], null);

        case "info":
          return /*#__PURE__*/_react["default"].createElement(_IconInfoOutline["default"], null);

        default:
          return "";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          displayCloseButton = _this$props.displayCloseButton,
          children = _this$props.children,
          htmlId = _this$props.htmlId;
      if (!this.state.isOpen) return null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: htmlId,
        className: "cx-alert cx-alert__".concat(type)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "cx-alert__icon"
      }, this.renderIcon(type)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "cx-alert__content"
      }, children), displayCloseButton && /*#__PURE__*/_react["default"].createElement("span", {
        className: "cx-alert__dismiss",
        onClick: this.handleCloseClick
      }, /*#__PURE__*/_react["default"].createElement(_IconClose["default"], null)));
    }
  }]);
  return Alert;
}(_react["default"].Component);

Alert.defaultProps = {
  displayCloseButton: false
};
var _default = Alert;
exports["default"] = _default;